import React, { useEffect, useRef } from 'react'
import { MenuItemType } from '@utils/types'
import { isOutsideClick } from '@utils/safe'
import { NavPanel, SimpleNavPanel } from '@components/molecules'
import styles from './NavDropdown.module.sass'

interface Props {
  item?: MenuItemType
  open?: boolean
  setOpen?: (v: boolean) => void
  className?: string
}

const NavDropdown = (props: Props) => {
  const { item = undefined, open = false, setOpen = undefined, className = '' } = props

  const ref = useRef(null)

  useEffect(() => {
    if (open) {
      const handleOutsideClick = (e) => {
        if (!!ref.current && !!setOpen) {
          if (!ref.current.contains(e.target)) {
            setOpen(false)
          }
        }
      }

      document.body.classList.add('w-noscroll')
      window.addEventListener('click', handleOutsideClick)
      return () => window?.removeEventListener('click', handleOutsideClick)
    } else {
      document.body.classList.remove('w-noscroll')
    }
  }, [open])

  return (
    <div
      className={`${styles.root} ${open ? styles['root--open'] : ''} ${
        item?.key !== 'prodotti' ? styles['root--simpleNav'] : ''
      } ${className}`}
      key={item.pk + 'panel'}
      ref={ref}
    >
      {item?.key === 'prodotti' ? <NavPanel item={item} /> : <SimpleNavPanel item={item} />}
    </div>
  )
}

export default NavDropdown
